import useAuth from '../../component/useAuth';
import Template from '../../component/Template';
import { useEffect } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React, { useRef } from "react";
import { Link } from 'react-router-dom';
import logo from "../../Assets/images/gif/danger.gif";
import { useNavigate } from 'react-router-dom';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import { useDownloadExcel } from 'react-export-table-to-excel';

export default function Roles() {

  const isAuth = useAuth();
  const navigate = useNavigate();
  if (isAuth === false) {
    navigate("/admin/")
  }


  const [isViewAccess, setViewAcess] = useState(false); //13/3/2024
  const [isCreateAccess, setCreateAcess] = useState(false);//13/3/2024
  const [isviewperm, setViewPerm] = useState(false);//13/3/2024
  const [roles, setRolesData] = useState([]);
  const [istost, settost] = useState(false);
  const tableRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [sortBy, setSortBy] = useState({ column: null, direction: 'asc' }); //sort

  const [totalroles, setTotalRoles] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredAndSortedData, setfilteredAndSortedData] = useState([]);

  //role validation -13/3/2024
  useEffect(() => {
    const access = async () => {
      const { http } = Api();
      const id = localStorage.getItem("id");
      try {
        const response = await http.get('/Admin/get-all-user-permissions', {params: { user_id: id }});  
      //console.log(response);
      const permissions = response.data;   
      permissions.forEach(permission => {
        if (permission.name ==="get-roles" ) { 
            setViewAcess(true);
          }
         
          if (permission.name ==="create-role") { 
            setCreateAcess(true);
          }
          
          if (permission.name ==="get-role-permissions") { 
            setViewPerm(true);
          }
           
        });
      } catch (error) {
        setViewAcess(false);
        setCreateAcess(false);
        setViewPerm(false);
      }
    };
    access();
  }, []);


  // Function to handle sorting
  const handleSort = (column) => {
    const newSortBy = {
      column,
      direction: sortBy.column === column && sortBy.direction === 'asc' ? 'desc' : 'asc',
    };
    setSortBy(newSortBy);
  };
  // Sort userlog based on sortBy state
  const roledata = [...roles].sort((a, b) => {
    if (sortBy.direction === 'asc') {
      return a[sortBy.column] > b[sortBy.column] ? 1 : -1;
    } else {
      return a[sortBy.column] < b[sortBy.column] ? 1 : -1;
    }
  });
  // Function to render sort icon
  const renderSortIcon = (columnName) => {
    if (sortBy.column === columnName) {
      return sortBy.direction === 'asc' ? <i className="fa fa-sort-up ml-1" aria-hidden="true"></i> : <i className="fa fa-sort-down ml-1" aria-hidden="true"></i>;
    }
    return <i className="fa fa-sort ml-1" aria-hidden="true"></i>; // Show disabled sort icon
  };
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: 'Roles Database',
    sheet: 'Roles',
  });

  useEffect(() => {
    settost(sessionStorage.getItem("message"));
    fetchData();
  }, [currentPage]);

  const fetchData = async () => {
    try {

      const { http } = Api();
      const response = await http.get(`/Admin/get-roles?page=${currentPage}`, {
        params: {
          limit: '50',
        }
      });
      setRolesData(response.data.data);
      //console.log("ok2");
      console.log(response);
      setTotalPages(Math.ceil(response.data.total / 50));
      setTotalRoles(response.data.total);

    } catch (error) {
      console.error('Error fetching user log data:', error);
      setTotalPages(0);
    }

    
  };



  useEffect(() => {
    if (istost) {
      toast.success(istost);
      sessionStorage.removeItem("message");
      settost(false);
    }
  }, [istost]);

  /*const handleDeleteSuccess = async () => {
    const { http } = Api();
    try {
      const response = await http.delete(`/Admin/deletefaculty/${deleteid}`);
      console.log(response);
      if (response.data.status_code === "MSG3") {
        setDelete(false);
        sessionStorage.setItem("message","Faculty deleted successfully!")
        window.location.reload();
      }
    } catch (error) {
      toast.error("Something went wrong"); // Show error toast
      console.error('Error deleting faculty:', error);
    }
  }*/

  const encodeID = rolename => {
    const encodedName = encodeURIComponent(rolename);
    //console.log("Encoded Role Name:", encodedName);
    //console.log("btoa(encodedName):", btoa(encodedName));
    return btoa(encodedName);
};





  const handleExportDropdownToggle = (event) => {
    const selectedValue = event.target.value;
    if (selectedValue === "1") {
      // Handle PDF conversion
    } else if (selectedValue === "2") {
      // Handle CSV conversion
    } else if (selectedValue === "3") {
      onDownload();
    }
  };
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
// Function to handle changes in the search input field
const handleSearchInputChange = (event) => {
  //console.log(event.target.value+"onchange");
  setSearchQuery(event.target.value);
};

useEffect(() => {
  const filteredAndSortedData = [...roles].filter(role => {
    return (
      role.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }).sort((a, b) => {
    if (sortBy.direction === 'asc') {
      return a[sortBy.column] > b[sortBy.column] ? 1 : -1;
    } else {
      return a[sortBy.column] < b[sortBy.column] ? 1 : -1;
    }
  });
  setfilteredAndSortedData(filteredAndSortedData);
}, [searchQuery, sortBy, roles]);


const [ismobile, setIsmobile] = useState(false);
const togglemenu = () => {
    setIsmobile(!ismobile);
};

  return (
    <>
      <ToastContainer />
      <Template>

        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
              <div className="card-header card-heading">
                  <div className="py-3 d-flex justify-content-between align-items-center">
                    <h5 className="lbl1">Roles</h5>
                    <div className="d-flex ml-auto">
                      {/* Responsive Dropdown or Hamburger Menu */}
                      <div className="dropdown d-lg-none">
                        <button
                          className="btn btn-light dropdown-toggle"
                          type="button"
                          id="mobileActionsDropdown"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded={ismobile}
                          onClick={togglemenu}
                        >
                          <i className="fas fa-bars"></i>
                        </button>
                        <div
                          className={`dropdown-menu dropdown-menu-right ${ismobile ? 'show' : ''}`}
                          aria-labelledby="mobileActionsDropdown"
                          style={{
                            margin: '10px 20px 20px -60px',
                            boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
                            borderRadius: '0.5rem',
                            overflow: 'hidden',
                            color: 'black',
                          }}
                        >
                  
                          <div className="dropdown-item py-3">
                            <select
                              className="form-select btn-border"
                              id="inputGroupSelect01"
                              onChange={handleExportDropdownToggle}
                              style={{ cursor: "pointer" }}
                            >
                              <option selected="">Export As</option>
                              <option value="1">Pdf</option>
                              <option value="2">Csv</option>
                              <option value="3">Excel</option>
                            </select>
                          </div>
                          <div className="dropdown-divider my-0"></div>
                          {isCreateAccess && (
                            <Link className="dropdown-item" to="/admin/addrole">
                              <i
                                className="bi bi-plus-circle-fill show"
                                style={{ cursor: "pointer", color: 'black' }}
                              > Add New</i>
                            </Link>
                          )}
                        </div>
                      </div>


                      {/* Desktop View */}
                      <div className="d-none d-lg-flex">
                        <div className="form-group">
                          <select className="form-select btn-border" id="inputGroupSelect01" onChange={handleExportDropdownToggle} style={{ cursor: "pointer" }}>
                            <option selected="">Export As</option>
                            <option value="1">Pdf</option>
                            <option value="2">Csv</option>
                            <option value="3">Excel</option>
                          </select>
                        </div>
                        &nbsp;&nbsp;
                        {isCreateAccess && (
                          <Link className="btn btn-primary form-group" to="/admin/addrole">
                            <span className="icon">&#43;</span>
                            <div className="txtsh"> Add New</div>
                          </Link>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                

                <div className="card-body pdg1 d-flex justify-content-center">
                  <div className="col-sm-12">
                    <div className="table-responsive ovrflw">
                      <div className='row'>
                      <div className='col-md-6 wdt' >
                            <p>
                              Showing {(currentPage - 1) * 50 + 1}{''}-
                              {Math.min((currentPage - 1) * 50 + 50, totalroles)} of {totalroles} entries
                            </p>
                          </div>
                        <div className='col-md-6 wdt' align='right'>
                        <input
                          type="text"
                          value={searchQuery}
                          onChange={handleSearchInputChange}
                          placeholder="Search..."
                          className='form-control'
                          style={{width:'300px'}}
                        /></div></div>
                    {isViewAccess ? (
                      <table className="display dataTable table-striped table-bordered" ref={tableRef} style={{ width: "50%" }}>
                        <thead>
                          <tr className="bg-primary">
                            <th >Sl No &nbsp;
                            </th>
                            <th onClick={() => handleSort('name')}>Role name &nbsp;
                              {renderSortIcon('name')}</th>

                              {isviewperm && (
                            <th>Action</th>
                              )}

                          </tr>
                        </thead>
                        
                        
                          <tbody>
                            {filteredAndSortedData.map((roles,index) => {
                              
                               const serialNumber = (currentPage - 1) * 50 + index + 1;
                                

                              return (
                                <tr key={roles.id}>
                                  <td>{serialNumber}</td>
                                  <td>{roles.name}</td>
                                  {isviewperm && (
                                  <td>
                                  <Link to={`/admin/rolebypermission/${encodeID(roles.name)}`}>View/Map Permissions</Link>
                                  </td>
                                  )}
                                </tr>
                              );

                            })}
                          </tbody>
                      </table>
                    ) : (

                      <center><h5></h5></center>
                    )
                  
                  }
                   
                    </div>
                    {totalPages > 1 && (
                               <nav aria-label="..." style={{ cursor: "pointer" }}>
                               <ul className="pagination justify-content-center">
                                   <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                       <span className="page-link pgn-clr" onClick={handlePreviousPage}><i class="bi bi-arrow-left-circle-fill"></i></span>
                                   </li>
                                   <li className={`page-item`}>
                                       <span className="page-link pgn-clr" onClick={() => handlePageChange(1)}>1</span>
                                   </li>
                                   {currentPage > 4 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}
                                   {[...Array(totalPages - 1).keys()].slice(currentPage > 4 ? currentPage - 3 : 1, currentPage + 2).map((pageNumber) => (
                                       <li key={pageNumber} className={`page-item ${pageNumber + 1 === currentPage ? 'act-clr' : ''}`}>
                                           <span className="page-link pgn-clr" onClick={() => handlePageChange(pageNumber + 1)}>{pageNumber + 1}</span>
                                       </li>
                                   ))}
                                   {currentPage < totalPages - 3 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}

                                   <li className={`page-item`}>
                                       <span className="page-link pgn-clr" onClick={() => handlePageChange(totalPages)}>{totalPages}</span>
                                   </li>

                                   <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                       <span className="page-link pgn-clr" onClick={handleNextPage}><i class="bi bi-arrow-right-circle-fill"></i></span>
                                   </li>
                               </ul>
                           </nav>
                    )}
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </Template>
    </>
  );
}
